import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	aIDisclaimer: {
		id: 'custom-sites-extensions.link-cards.description.ai-disclaimer',
		defaultMessage: 'Content quality may vary',
		description:
			'Text that shows AI disclaimer when user generates description using AI in the link cards config panel',
	},
	aIAttributionLabel: {
		id: 'custom-sites-extensions.link-cards.description.link.label.ai',
		defaultMessage: 'Learn more about Atlassian AI',
		description: 'Link label to learn more about Atlassian AI',
	},
});
